<template>
  <!-- MODAL -->
  <div class="modal fade" id="editCategory">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content card">
        <div class="modal-header card-header border-0">
          <h5 class=" card-title text-truncate" id="exampleModalLabel">Update Kategori</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body bg-white">
          <div class="alert alert-info text-left" style="font-size:13px;">
            Pilih kategori baru untuk produk <strong>{{editState.name}}</strong><br>
            
          </div>
            <div class="card-chart card-body">
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-3">
                    <img :src="editState.image" class="" height="200px" alt="">
                  </div>
                  <div class="col-md-9 align-self-center">
                    <p style="font-size:13.5px;" class="text-wrap text-dark text-left">Nama Produk :
                      <strong> {{editState.name}}</strong>
                    </p>
                    <p  style="font-size:13.5px;" class="text-wrap text-dark text-left mb-3">Kategori yang dipilih : <span id="resultBarangCategory" class="text-center mt-5"></span></p>
                     
                    <div class="form-group row">
                      <div class="col-lg-4">
                        <label id="label_cat1" aria-label="nonBookCategory">Kategori 1</label>
                        <select @change="getCategoryVal" name="nonBookCategory" id="nonBookCategory"
                          class="is-invalid form-control" >
                          <option v-for="(lc, index) in listCategory" :key="index" :value="lc.id">
                            {{ lc.title }}
                          </option>
                        </select>
                        <div class="invalid-feedback">
                          Pilih Kategori
                        </div>
                      </div>

                      <p id="loadingCategory1" class="mt-1 d-none small">
                        Loading <i class="fa fa-spinner fa-spin"></i>
                      </p>

                      <div class="col-lg-4">
                      <label id="label_cat2" aria-label="nonBookSubCategory">Sub Kategori</label>
                        <select @change="getSubCategoryVal" name="nonBookSubCategory" id="nonBookSubCategory"
                          class="is-invalid form-control d-none" >
                          <option v-for="(lsc, index) in listSubCategory" :key="index" :value="lsc.id">
                            {{ lsc.title }}
                          </option>
                        </select>

                      </div>

                      <p id="loadingCategory2" class="mt-1 d-none small">
                        Loading <i class="fa fa-spinner fa-spin"></i>
                      </p>

                      <div class="col-lg-4">
                        <label id="label_cat3" aria-label="nonBookSub2Category">Sub Kategori</label>
                        <select @change="lastCategoryBarang" name="nonBookSub2Category" id="nonBookSub2Category"
                          class="form-control d-none is-invalid" >
                          <option v-for="(lsc, index) in listSub2Category" :key="index" :value="lsc.id">
                            {{ lsc.title }}
                          </option>
                        </select>
                      </div>

                    </div>
                
                  </div>
                </div>
              </div>
            </div>
          <p style="font-size:12px;"  class="text-wrap text-muted text-center"><i class="fa fa-info-circle"></i> Pilih kategori 1 terlebih dahulu kemudian lanjutkan dengan Sub Kategori dst.</p> 

          <!-- <a class="" data-toggle="collapse" href="#kategoriJasa">
              <p>
                <u>List Kategori Jasa</u>
              </p>
            </a> -->

          <!-- <div class="collapse" id="kategoriJasa">
                <div class="card card-body">
                  <div class="form-group row">
                  <div class="col-lg-3">
                    <select
                      @change="getCategoryValJasa"
                      name="jasaCategory"
                      id="jasaCategory"
                      class="form-control"
                    >
                      <option
                        v-for="(lc, index) in listCategoryJasa"
                        :key="index"
                        :value="lc.id"
                      >
                        {{ lc.title }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <select
                      @change="lastCategoryJasa"
                      name="jasaSubCategory"
                      id="jasaSubCategory"
                      class="form-control"
                    >
                      <option
                        v-for="(lsc, index) in listSubCategoryJasa"
                        :key="index"
                        :value="lsc.id"
                      >
                        {{ lsc.title }}
                      </option>
                    </select>
                  </div>
                </div>
                  <div id="resultJasaCategory"></div>
                </div>
              </div> -->




        </div>
        <div class="modal-footer bg-white border-0">
          <button type="button" class="btn btn-lg btn-secondary p-3 mr-1" data-dismiss="modal">
            Cancel
          </button>
          <button type="button" :disabled="disabledEditCategoryNonBook" class="btn btn-lg p-3 btn-primary"
            @click="saveEditCategory(editState.id)"><i class="fa fa-edit"></i> Update</button>
        </div>
      </div>
    </div>
  </div>
  <!-- END MODAL -->
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        canSave: true
      }
    },
    props: {
      editState: {},
      getCategoryVal: Function,
      getSubCategoryVal: Function,
      lastCategoryBarang: Function,
      disabledEditCategoryNonBook: Boolean,

      listCategory: Array,
      listSubCategory: Array,
      listSub2Category: Array,

      listCategoryJasa: Array,
      getCategoryValJasa: Function,
      listSubCategoryJasa: Function,
      lastCategoryJasa: Function,

      saveEditCategory: Function,

    },
    updated() {
      if($('#nonBookSubCategory').hasClass('d-none')){
        $('#label_cat2').addClass('d-none')
      }else{
        $('#label_cat2').removeClass('d-none')
      }

      setTimeout(() => {
        
        if($('#nonBookSub2Category').hasClass('d-none')){
          $('#label_cat3').addClass('d-none')
        }else{
          $('#label_cat3').removeClass('d-none')
        }
      }, 200);

      
    }

  }
</script>